import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-448063e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-menu"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-heading grow-1" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "c-primary" }, "Auto"),
    /*#__PURE__*/_createTextVNode("Proc")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ap-circle circle-md mx-8" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-person" })
], -1))
const _hoisted_4 = { class: "welcome-msg" }
const _hoisted_5 = {
  name: "welcome-msg-user-name",
  class: "btn-link"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ap-icon ap-icon-earth",
  style: {"font-size":"22px","margin-inline-start":"10px"}
}, null, -1))
const _hoisted_7 = { class: "content-frame" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-sm-right fs-sm" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-projects" }, null, -1))
const _hoisted_11 = { class: "text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-sm-right fs-sm" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-datastructure" }, null, -1))
const _hoisted_14 = { class: "text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-sm-right fs-sm" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-contacts" }, null, -1))
const _hoisted_17 = { class: "text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-sm-right fs-sm" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-sms" }, null, -1))
const _hoisted_20 = { class: "text" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-sm-right fs-sm" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-envelope" }, null, -1))
const _hoisted_23 = { class: "text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-sm-right fs-sm" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-landings" }, null, -1))
const _hoisted_26 = { class: "text" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-sm-right fs-sm" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ap-icon ap-icon-lightning",
  style: {"font-size":"22px"}
}, null, -1))
const _hoisted_29 = { class: "text" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-sm-right fs-sm" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-settings" }, null, -1))
const _hoisted_32 = { class: "text" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-sm-right fs-sm" }, null, -1))
const _hoisted_34 = { class: "link-title" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-divider" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-page" }, null, -1))
const _hoisted_38 = { class: "v-center d-flex over-hidden" }
const _hoisted_39 = { class: "text mis-12 truncate-text" }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grow-1" }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-select" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, /*#__PURE__*/_toDisplayString('Design Elements'), -1))
const _hoisted_44 = ["data-tooltip"]
const _hoisted_45 = {
  key: 1,
  class: "ap-icon ap-icon-arrow-sm-left"
}
const _hoisted_46 = {
  key: 3,
  class: "w-100 text-right pr24 c-primary"
}
const _hoisted_47 = { class: "jobs-container" }
const _hoisted_48 = { class: "d-flex grow-1 mx-2" }
const _hoisted_49 = ["href"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = { key: 3 }
const _hoisted_53 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_icon = _resolveComponent("ap-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_EmailProfileModal = _resolveComponent("EmailProfileModal")!
  const _component_SMSProfileModal = _resolveComponent("SMSProfileModal")!
  const _component_SmsTemplateModal = _resolveComponent("SmsTemplateModal")!
  const _component_NewsletterModal = _resolveComponent("NewsletterModal")!
  const _component_SendTestSms = _resolveComponent("SendTestSms")!
  const _component_SendTestEmail = _resolveComponent("SendTestEmail")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass({ 'no-header': _ctx.IsIframe })
  }, [
    (_ctx.IsIframe == false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            class: "user-info",
            onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.LanguageSelectingStarted = false))
          }, [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.header.hello')), 1),
              _createTextVNode("  "),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.UserFullName), 1)
            ]),
            _createElementVNode("a", null, [
              _createElementVNode("span", {
                class: "btn-link disconnect-link",
                name: "disconnect-link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLogout && _ctx.onLogout(...args)))
              }, _toDisplayString(_ctx.$t('general.header.logout')), 1)
            ]),
            _createElementVNode("span", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.LanguageSelectingStarted = !_ctx.LanguageSelectingStarted)),
              style: {"cursor":"pointer","position":"relative"}
            }, [
              _hoisted_6,
              (_ctx.LanguageSelectingStarted)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["text language-box d-flex", _ctx.LanguageSelectingStarted ? 'flex' : 'none']),
                    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.LanguageSelectingStarted = false))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["lang-item", { 'active-lang': _ctx.Lang === 'he-IL' }])
                    }, [
                      _createElementVNode("img", {
                        src: "/israel.svg",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ChangeLang('he-IL')))
                      })
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["lang-item", { 'active-lang': _ctx.Lang === 'en-US' }])
                    }, [
                      _createElementVNode("img", {
                        src: "/usa.svg",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ChangeLang('en-US')))
                      })
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["lang-item", { 'active-lang': _ctx.Lang === 'ru-RU' }])
                    }, [
                      _createElementVNode("img", {
                        src: "/russia.svg",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ChangeLang('ru-RU')))
                      })
                    ], 2)
                  ], 34))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("aside", {
        ref: "sidebar",
        class: _normalizeClass(["sidebar", { collapsed: _ctx.IsMenuCollapsed }])
      }, [
        _createVNode(_component_router_link, {
          to: { name: 'home' },
          class: "menu-item",
          title: _ctx.$t('menu.home')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ap_icon, { icon: "home" }),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('menu.home')), 1),
            _hoisted_9
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_router_link, {
          to: "/manage",
          class: "menu-item",
          title: _ctx.$t('menu.projects')
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('menu.projects')), 1),
            _hoisted_12
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_router_link, {
          to: "/data-structures",
          class: "menu-item",
          title: _ctx.$t('menu.datastructures')
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('menu.datastructures')), 1),
            _hoisted_15
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_router_link, {
          to: { name: 'contacts' },
          class: "menu-item",
          title: _ctx.$t('menu.contacts')
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('menu.contacts')), 1),
            _hoisted_18
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_router_link, {
          to: { name: 'sms-list' },
          class: "menu-item",
          title: _ctx.$t('menu.sms')
        }, {
          default: _withCtx(() => [
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('menu.sms')), 1),
            _hoisted_21
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_router_link, {
          to: { name: 'emails-list' },
          class: "menu-item",
          title: _ctx.$t('menu.email')
        }, {
          default: _withCtx(() => [
            _hoisted_22,
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('menu.email')), 1),
            _hoisted_24
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_router_link, {
          to: { name: 'landing-pages' },
          class: "menu-item",
          title: _ctx.$t('menu.landing-pages')
        }, {
          default: _withCtx(() => [
            _hoisted_25,
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('menu.landing-pages')), 1),
            _hoisted_27
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_router_link, {
          to: { name: 'automations' },
          class: "menu-item",
          title: _ctx.$t('menu.automations')
        }, {
          default: _withCtx(() => [
            _hoisted_28,
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('menu.automations')), 1),
            _hoisted_30
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_router_link, {
          to: { name: 'settings' },
          class: "menu-item",
          title: _ctx.$t('menu.settings')
        }, {
          default: _withCtx(() => [
            _hoisted_31,
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('menu.settings')), 1),
            _hoisted_33
          ]),
          _: 1
        }, 8, ["title"]),
        (_ctx.$route.name == 'new-page')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/new-page",
              class: "menu-item"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('menu.new')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.CurrentPageId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _hoisted_36,
              _createVNode(_component_router_link, {
                to: { name: 'page-form', params: { id: _ctx.CurrentPageId } },
                class: _normalizeClass(["menu-item", { 'router-link-active': _ctx.$route.params.id }]),
                title: _ctx.$t('menu.page') + ': ' + _ctx.PageName(_ctx.CurrentPageId)
              }, {
                default: _withCtx(() => [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('menu.page')) + ": " + _toDisplayString(_ctx.PageName(_ctx.CurrentPageId)), 1)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["page-status-circle mis-4", _ctx.PageStatusClass(_ctx.CurrentPageId)])
                  }, null, 2)
                ]),
                _: 1
              }, 8, ["to", "class", "title"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.IsMenuCollapsed && _ctx.IsIframe == false)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_40, "Will be removed"))
          : _createCommentVNode("", true),
        _hoisted_41,
        _createVNode(_component_router_link, {
          to: { name: 'style-sample-page' },
          class: "menu-item",
          title: _ctx.$t('menu.dashboard')
        }, {
          default: _withCtx(() => [
            _hoisted_42,
            _hoisted_43
          ]),
          _: 1
        }, 8, ["title"]),
        _createElementVNode("button", {
          class: "menu-control-btn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.ToggleMenu(!_ctx.IsMenuCollapsed)))
        }, [
          (_ctx.IsMenuCollapsed)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "ap-icon ap-icon-arrow-sm-right",
                "data-tooltip": _ctx.$t('footer.actions.showmenu')
              }, null, 8, _hoisted_44))
            : (_openBlock(), _createElementBlock("i", _hoisted_45))
        ]),
        (_ctx.BuildVersion)
          ? (_openBlock(), _createElementBlock("span", _hoisted_46, "v." + _toDisplayString(_ctx.BuildVersion), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_47, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ExportJobs, (job) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["job-item ap-badge", {
                        'badge-success': job.ReportUrl,
                        'badge-danger': job.Message,
                    }]),
            key: job.Id
          }, [
            _createElementVNode("div", _hoisted_48, [
              (job.ReportUrl)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: job.ReportUrl,
                    target: "_blank"
                  }, _toDisplayString(_ctx.$t('export.message.' + job.Type + '.success')), 9, _hoisted_49))
                : (job.Message)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t('export.message.' + job.Type + '.error')), 1))
                  : (job.State == 'Enqueued')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.$t('export.message.' + job.Type + '.starting')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t('export.message.' + job.Type + '.in-progress')), 1))
            ]),
            (job.ReportUrl || job.Message)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: "ap-icon ap-icon-x clickable fs-sm",
                  onClick: ($event: any) => (_ctx.deleteExportJobs(job))
                }, null, 8, _hoisted_53))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _createElementVNode("section", {
        class: "main",
        style: _normalizeStyle({ padding: _ctx.ContentPadding })
      }, [
        _createVNode(_component_router_view)
      ], 4)
    ]),
    _createVNode(_component_EmailProfileModal, { name: "email-profile" }),
    _createVNode(_component_SMSProfileModal, { name: "sms-profile" }),
    _createVNode(_component_SmsTemplateModal, {
      onOnCreateSmsTemplate: _ctx.onCreateSmsTemplate,
      name: "sms-template_modal"
    }, null, 8, ["onOnCreateSmsTemplate"]),
    _createVNode(_component_NewsletterModal, {
      onOnCreateNewsletter: _ctx.onCreateNewsletter,
      name: "newsletter_modal"
    }, null, 8, ["onOnCreateNewsletter"]),
    _createVNode(_component_SendTestSms, { name: "send_test_sms" }),
    _createVNode(_component_SendTestEmail, { name: "send_test_email" })
  ], 2))
}